import Domain from "../../../platform/models/domain/domain-base";

export class ResetPasswordPolicyOptions extends Domain {
  autoEnrollEnabled = false;
}
